/* ============================================================================
   EMIRATI WOMEN'S DAY 2026 — campaign motion + optional real countdown.
   - IntersectionObserver reveal (opacity/transform only)
   - Optional countdown from a REAL merchant end datetime (no fake timers)
   - prefers-reduced-motion: reveals immediately, no drift
   - Idempotent: safe under Theme Editor section add/remove/reload
   - Exits cleanly if nothing on the page uses it
   ============================================================================ */
(function () {
  'use strict';

  if (window.__ewdCampaign) {
    // Script tag included by multiple sections — bind listeners only once,
    // but still run a pass for any freshly-rendered nodes.
    window.__ewdCampaign.run(document);
    return;
  }

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  /* ---------- Reveal ---------- */
  var revealObserver = null;
  function getRevealObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    return revealObserver;
  }

  function initReveals(root) {
    var nodes = (root || document).querySelectorAll('[data-ewd-reveal]');
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    var io = getRevealObserver();
    nodes.forEach(function (n) {
      if (n.dataset.ewdSeen === '1') return;
      n.dataset.ewdSeen = '1';
      io.observe(n);
    });
  }

  /* ---------- Optional real countdown ---------- */
  var timers = [];
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tickCountdown(el, end) {
    var diff = end - Date.now();
    if (diff <= 0) {
      el.hidden = true;
      return false;
    }
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    var secs = Math.floor((diff % 60000) / 1000);
    var set = function (key, val) {
      var node = el.querySelector('[data-cd="' + key + '"]');
      if (node) node.textContent = pad(val);
    };
    set('days', days); set('hours', hours); set('mins', mins); set('secs', secs);
    return true;
  }

  function initCountdowns(root) {
    var nodes = (root || document).querySelectorAll('[data-ewd-countdown]');
    nodes.forEach(function (el) {
      if (el.dataset.ewdCdInit === '1') return;
      var end = Date.parse(el.dataset.end);
      if (isNaN(end)) { el.hidden = true; return; }
      el.dataset.ewdCdInit = '1';
      if (!tickCountdown(el, end)) return;
      el.hidden = false;
      var id = setInterval(function () {
        if (!document.body.contains(el) || !tickCountdown(el, end)) clearInterval(id);
      }, 1000);
      timers.push(id);
    });
  }

  /* ---------- Public run ---------- */
  function run(root) {
    initReveals(root);
    initCountdowns(root);
  }

  window.__ewdCampaign = { run: run };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  /* Theme Editor: re-init only the reloaded section */
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();